<template>
  <tr>
    <td width="105px" class="client-id">{{item.client_id}}</td>
    <td width="90px">{{item.login}}</td>
    <td>{{item.first_name}} {{item.last_name}}</td>
    <td>{{formatDate(item.date)}}</td>
    <td>{{cashingDate(item.date)}} Дней до перевода: {{ daysToCashing(item.date) }}</td>
    <td width="200px">{{item.transfer_number}}</td>
    <td width="160px">
      <CustomDialog
          :visible="showFromAccDialog"
          @close="showFromAccDialog = false"
          title="Modal Bank Data"
          :confirmBtnText="null"
      >
        <template v-slot:body>
          <div class="row">
            <b>Balance:</b> <span>{{item.balance}}</span>
          </div>
        </template>
      </CustomDialog>
      <a class="tooltipped" @click="showFromAccDialog = true" data-position="top" :data-tooltip="balance_statistic">{{item.account_special_number}}
        ({{item.currency_abbreviation}})
      </a>
    </td>
    <td width="300px"> {{lineBreak(item.beneficiary_name)}}</td>
    <td>{{item.amount}}</td>
    <td>{{item.status_name}}</td>

    <td>
<!--      <div v-if="item.status_name === 'pending'" class="buttons-container">-->
      <div class="buttons-container">
        <a v-if="item.status_name === 'hold'" @click="cashing(item.transfer_number)" class="waves-effect waves-light btn"  v-bind:class="isDisabledTransferButton"  v-bind:id="'button_' + item.transfer_number">transfer money</a>
      </div>
    </td>
  </tr>
</template>

<script>
  import { required } from "vuelidate/lib/validators"
  import CustomDialog from "../CustomDialog"

  export default {
    props: { item: Object },

    data: () => ({
      reference: '',
      showIbanDialog: false,
      showFromAccDialog: false
    }),
    methods: {
      lineBreak(string) {
        return string.replace('\n', ' |')
      },
      async cashing(transactionNumber) {
        let button = document.getElementById('button_' + transactionNumber)
        button.classList.add('disabled')
        window.console.log('CLICK !! - ', button, transactionNumber)

        let res = await this.$store.dispatch('request', {
          path: 'admin/unfreezes/monies', body: {
            transactionNumber: transactionNumber,
          }
        });

        if (res.message === 'OK') {
          this.item.status_name = 'Confirmed'
        } else {
          this.item.status_name = 'Error'
          alert("Error: " + res.errors);
        }

      },
      cashingDate(date) {
        let transactionCreateDate = new Date(date);
        let transactionCashingDate = transactionCreateDate.setDate(transactionCreateDate.getDate() + 7);
        return this.formatDate(transactionCashingDate)
      },
      daysToCashing(date) {
        let transactionCreateDate = new Date(date);
        let cashingDate = new Date(this.cashingDate(transactionCreateDate))
        const diffTime = Math.abs(cashingDate - transactionCreateDate);
        return  Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      },
      formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;

        return [year, month, day].join('-');
      },
    },
    validations: {
      reference: { required },
    },

    computed: {
      balance_statistic: function () {
        return 'balance: ' + this.item.balance + ' / min: ' + this.item.min_balance
      },
      isDisabledTransferButton: function () {
        if (this.daysToCashing(this.item.date) <= 0) {
          return { disabled: false}
        } else {
          return { disabled: true}
        }
      }
    },

    components: {
      CustomDialog,
    },
  }
</script>

<style lang="scss" scoped>
  .client-id {
    text-align: center;
  }

  .main_div {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
  .tooltipped {
    cursor: pointer;
  }

  .td-main-btn {
    margin-top: 10px;
  }

  .helper-text {
    color: red;
  }

  td {
    padding: 15px 25px 15px 0;
  }

  .buttons-container {
    display: flex;
    flex-direction: row;
  }

  .accept-button,
  .close-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .accept-button {
    background: #26a69a;
    margin-right: 5px;
  }

  .close-button {
    background: #cc3f55;
  }

  .link {
    cursor: pointer;
  }
</style>
